import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';
import { useToasted } from '~/composables/useToasted';
import promotionsClient from '~/services/promotionsClient';
import { catchRequestError } from '~/utils/request';

const defaultPromotion = () => {
    return {
        name: '',
        code: '',
    };
};

export const usePromotionDetails = createGlobalState(() => {
    const toasted = useToasted();
    const teamId = Spark.state.currentTeam.id;

    const promotion = ref(defaultPromotion());
    const loading = ref(false);
    const saving = ref(false);
    const error = ref('');

    let onMountedPromotionCallback = () => {};
    const onMountedPromotion = (callback) => {
        onMountedPromotionCallback = callback;
    };
    const mount = async (promotionId) => {
        promotion.value = defaultPromotion();

        if (!promotionId) {
            onMountedPromotionCallback?.();
            return;
        }

        promotion.value.id = promotionId;
        loading.value = true;

        try {
            const response = await promotionsClient.getPromotion(teamId, promotionId);
            promotion.value = response.data;
            loading.value = false;
            onMountedPromotionCallback?.();
        } catch (e) {
            error.value = catchRequestError(e);
            toasted?.error(error.value);
        }
    };

    const save = async () => {
        if (saving.value) {
            return;
        }

        saving.value = true;
        error.value = '';

        try {
            const response = await promotionsClient.savePromotion(teamId, promotion.value.id, promotion.value);

            return response.data;
        } catch (e) {
            error.value = catchRequestError(e);
            toasted?.error(error.value);

            throw e;
        } finally {
            saving.value = false;
        }
    };

    return {
        promotion,
        loading,
        saving,
        error,
        onMountedPromotion,
        mount,
        save,
    };
});
